module.exports = __webpack_public_path__ + "static/mision_vision_background-5e3ec7bebf52f27055f0fed7be2bf8ab.jpeg";